// extracted by mini-css-extract-plugin
export default {"main":"Auth_main__3ZHrm","center":"Auth_center__L0b95","auth":"Auth_auth__4Fbe3","logo":"Auth_logo__olog5","into":"Auth_into__o79js","btn":"Auth_btn__MLRah"};